export const safeParseJson = <TValue>(
  value: string,
  fallback: TValue,
): TValue => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};
